import { render } from "./DepositChart.vue?vue&type=template&id=c96ba4b4&scoped=true"
import script from "./DepositChart.vue?vue&type=script&lang=js"
export * from "./DepositChart.vue?vue&type=script&lang=js"

import "./DepositChart.vue?vue&type=style&index=0&id=c96ba4b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c96ba4b4"]])

export default __exports__